export const SET_NAVIGATION_STATE = "SET_NAVIGATION_STATE";

export interface NavigationState {
  title?: string | JSX.Element;
  left?: React.ReactNode;
  right?: React.ReactNode;
  bottom?: React.ReactNode;
  themed?: boolean;
  expanded?: boolean;
  hidden?: boolean;
  border?: boolean;
}

export interface SetNavigationStateAction {
  type: typeof SET_NAVIGATION_STATE;
  state: NavigationState;
}

export type NavigationActionTypes = SetNavigationStateAction;
